"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
const TableCell = _ref => {
  let {
    data,
    column
  } = _ref;
  const cellContent = _react.default.useMemo(() => {
    const columnInfoCell = column.cellComponent;
    if ((0, _ark.isDefined)(columnInfoCell) && (0, _ark.isFunction)(columnInfoCell.props.children)) {
      return columnInfoCell.props.children({
        data
      });
    }
    return (0, _ark.getPropertySafe)(data, column?.accessor) ?? '';
  }, [column, data]);
  return /*#__PURE__*/_react.default.createElement("td", {
    className: (0, _arkReact.concatClassName)('tableCol', column.className)
  }, cellContent);
};
var _default = exports.default = TableCell;